import $ from 'jquery'
import _ from 'underscore'
import StateManager from '../scuba/StateManager'

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
  $(node)
    .find('input[autofocus]')
    .each(function(i, el) {
      $(el).focus()
    })
  $(node)
    .find('input[name="text"]')
    .each(function(i, el) {
      $(el).on('focus', e => {
        $(el).val('')
        $(el).trigger('change')
      })
    })
})



// WEBPACK FOOTER //
// ./scripts/components/AutoFocus.js